import { render, staticRenderFns } from "./DB4.vue?vue&type=template&id=dc84956e&scoped=true&"
import script from "./DB4.vue?vue&type=script&lang=js&"
export * from "./DB4.vue?vue&type=script&lang=js&"
import style0 from "./DB4.vue?vue&type=style&index=0&id=dc84956e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc84956e",
  null
  
)

export default component.exports